var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',_vm._b({attrs:{"elevation":"0","color":"transparent","disabled":_vm.disabled,"flat":""}},'v-card',_vm.$attrs,false),[_c('div',{staticClass:"text-center",attrs:{"id":"paypal-buttons"}})])}
var staticRenderFns = []

export { render, staticRenderFns }